import raveIf from '@magalu/rave/template/rave-if';
import unique from '../../parser/route/unique';

export const getComponents = props => ({
    'header-preconnect-0': {
      name: `Preconnect`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        list: [
          `https://wx.mlcdn.com.br`,
          `https://6590300.fls.doubleclick.net`,
          `https://a-static.mlcdn.com.br`,
          `https://ad.doubleclick.net`,
          `https://analytics.pangle-ads.com`,
          `https://analytics.tiktok.com`,
          `https://analytics.twitter.com`,
          `https://bat.bing.com`,
          `https://c.bing.com`,
          `https://c.clarity.ms`,
          `https://cas.avalon.perfdrive.com`,
          `https://cdn.perfdrive.com`,
          `https://connect.facebook.net`,
          `https://ct.pinterest.com`,
          `https://d.clarity.ms`,
          `https://gum.criteo.com`,
          `https://i.btg360.com.br`,
          `https://s.pinimg.com`,
          `https://sc-static.net`,
          `https://script.hotjar.com`,
          `https://site-content.magazineluiza.com.br`,
          `https://static.ads-twitter.com`,
          `https://static.criteo.net`,
          `https://static.hotjar.com`,
          `https://t.co`,
          `https://tags.creativecdn.com`,
          `https://td.doubleclick.net`,
          `https://tom.mlcdn.com.br`,
          `https://tr.snapchat.com`,
          `https://tr6.snapchat.com`,
          `https://us.creativecdn.com`,
          `https://www.clarity.ms`,
          `https://www.facebook.com`,
        ],
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-preconnect-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-script-1': {
      name: `Script`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        src: `https://wx.mlcdn.com.br/shared/azion/azfp-63fe5.min.js`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-script-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-all-in-2': {
      name: `AllIn`,
      from: `@magalu/ecomm-components/rave/scripts/AllIn`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-all-in-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-criteo-3': {
      name: `Criteo`,
      from: `@magalu/ecomm-components/rave/scripts/Criteo`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-criteo-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-tik-tok-4': {
      name: `TikTok`,
      from: `@magalu/ecomm-components/rave/scripts/TikTok`,
      props: {
        id: `C1I87V1T0U322RQPSRKG`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-tik-tok-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-rtbhouse-5': {
      name: `RTBHouse`,
      from: `@magalu/ecomm-components/rave/scripts/RTBHouse`,
      props: {
        id: `msWukR4UlwKQouZSY8IT`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-rtbhouse-5`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-stewie-6': {
      name: `Stewie`,
      from: `@magalu/ecomm-components/rave/scripts/Stewie`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-stewie-6`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-spotify-ad-analytics-7': {
      name: `SpotifyAdAnalytics`,
      from: `@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics`,
      props: {
        id: `66f417c2d2344c0980e19d4e7f996073`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-spotify-ad-analytics-7`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-hotjar-8': {
      name: `Hotjar`,
      from: `@magalu/ecomm-components/rave/scripts/Hotjar`,
      props: {
        id: `4936838`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-hotjar-8`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-9': {
      name: `Loader`,
      from: `@magalu/ecomm-components/rave/Loader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-loader-9`,
      spacing: {
      },
      ssr: false,
    },
    'header-state-loader-10': {
      name: `StateLoader`,
      from: `@magalu/ecomm-components/rave/StateLoader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-state-loader-10`,
      spacing: {
      },
      ssr: false,
    },
    'header-event-page-view-dispatcher-11': {
      name: `EventPageViewDispatcher`,
      from: `@magalu/ecomm-components/rave/EventPageViewDispatcher`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-event-page-view-dispatcher-11`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-9-children-page-loading-0': {
      name: `PageLoading`,
      from: `@magalu/ecomm-components/components/PageLoading`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-loader-9-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-state-loader-10-children-page-loading-0': {
      name: `PageLoading`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      from: `@magalu/ecomm-components/components/PageLoading`,
      displayCondition: null,
      hasSpacing: false,
      id: `header-state-loader-10-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex flex-col items-center w-full`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-1': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex flex-col items-center w-full p-xsm`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-1`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-2': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `m-md flex flex-col items-center overflow-hidden`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-2`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-3': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex flex-col items-center w-full p-xsm`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-3`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-4': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `m-md flex flex-col items-center`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-4`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-seller-header-page-0': {
      name: `SellerHeaderPage`,
      from: `@magalu/ecomm-components/rave/SellerHeaderPage`,
      props: {
        sellerInfo: {
          headerImageSrc: `https://wx.mlcdn.com.br/seller-page/default/desktop/header.jpeg`,
          sellerLogoSrc: `https://wx.mlcdn.com.br/site/shared/sellers/third-party.png`,
          backgroundColor: `bg-surface-container-low`,
          colorPrimary: `bg-brand-default`,
          colorSecondary: `text-surface-container-lowest`,
          showButtons: true,
          id: props?.route?.query?.sellerId,
        },
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-seller-header-page-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-1-children-banner-carousel-0': {
      name: `BannerCarousel`,
      from: `@magalu/ecomm-components/rave/BannerCarousel`,
      props: {
        size: `large`,
        position: 1,
        page: `seller-page`,
        bannerKey: `primaryBanner`,
        images: [
          `https://wx.mlcdn.com.br/seller-page/default/desktop/banner_1.jpeg`,
        ],
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-1-children-banner-carousel-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-2-children-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex flex-row justify-between items-center w-full xlg:max-w-[1280px]`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-2-children-row-0`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-2-children-row-0-children-heading-0': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        as: `h2`,
        title: raveIf([
          props?.data?.sellerPage?.productSlide?.settings?.category?.id,
          props?.data?.sellerPage?.productSlide?.title,
          `Mais vendidos`,
        ]),
        className: `font-medium text-xl`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-2-children-row-0-children-heading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-2-children-row-0-children-button-1': {
      name: `Button`,
      from: `@magalu/ecomm-components/rave/Button`,
      props: {
        color: `primary`,
        variant: `invisible`,
        label: `Ver mais`,
        href: `${props?.clientConfig?.siteDomain}/busca/${props?.route?.query?.sellerId}`,
        className: `font-medium text-lg`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-2-children-row-0-children-button-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-2-children-product-list-1': {
      name: `ProductList`,
      from: `@magalu/ecomm-components/rave/ProductList`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      props: {
        variant: `inline`,
        type: `productSlide`,
        pagination: {
          page: 1,
          pageSize: 10,
        },
        URLParams: {
          sellerId: props?.route?.query?.sellerId,
        },
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-2-children-product-list-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-3-children-banner-carousel-0': {
      name: `BannerCarousel`,
      from: `@magalu/ecomm-components/rave/BannerCarousel`,
      props: {
        size: `large`,
        position: 2,
        page: `seller-page`,
        bannerKey: `secondaryBanner`,
        images: [
          `https://wx.mlcdn.com.br/seller-page/default/desktop/banner_2.jpeg`,
        ],
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-3-children-banner-carousel-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-4-children-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex flex-row justify-between items-center w-full xlg:max-w-[1280px]`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-4-children-row-0`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-4-children-row-0-children-heading-0': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        as: `h2`,
        title: raveIf([
          props?.data?.sellerPage?.productGrid?.settings?.category?.id,
          props?.data?.sellerPage?.productGrid?.title,
          `Todos os produtos`,
        ]),
        className: `font-medium text-xl`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-4-children-row-0-children-heading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-4-children-row-0-children-button-1': {
      name: `Button`,
      from: `@magalu/ecomm-components/rave/Button`,
      props: {
        color: `primary`,
        variant: `invisible`,
        label: `Ver mais`,
        href: `${props?.clientConfig?.siteDomain}/busca/${props?.route?.query?.sellerId}/?page=1&sortOrientation=desc?sortType=soldQuantity`,
        className: `font-medium text-lg`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-4-children-row-0-children-button-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-4-children-product-list-1': {
      name: `ProductList`,
      from: `@magalu/ecomm-components/rave/ProductList`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      props: {
        type: `productGrid`,
        pagination: {
          page: 1,
          pageSize: 10,
        },
        URLParams: {
          sellerId: props?.route?.query?.sellerId,
          sortOrientation: `desc`,
          sortType: `soldQuantity`,
        },
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-4-children-product-list-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'footer-version-tag-0': {
      name: `VersionTag`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `footer-version-tag-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-back-to-top-1': {
      name: `BackToTop`,
      from: `@magalu/ecomm-components/components/BackToTop`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `footer-back-to-top-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
  });

export const dataSource = {
  "graphql": {
    "configsDir": "config",
    "host": "https://federation.magazineluiza.com.br",
    "timeout": 5000
  }
}

export const getHeadProps = (props) => ({
    links: [
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/fonts/magalu-ui-variable/files/MagaluUIVariable.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.woff`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/truetype`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.ttf`,
        crossOrigin: ``,
      },
    ],
    meta: [
      {
        name: `viewport`,
        content: `width=device-width, initial-scale=1.0, user-scalable=no, maximum-scale=1.0`,
      },
    ],
  });

export const componentsList = [
  "Preconnect",
  "Script",
  "AllIn",
  "Criteo",
  "TikTok",
  "RTBHouse",
  "Stewie",
  "SpotifyAdAnalytics",
  "Hotjar",
  "Loader",
  "StateLoader",
  "EventPageViewDispatcher",
  "PageLoading",
  "Row",
  "SellerHeaderPage",
  "BannerCarousel",
  "Heading",
  "Button",
  "ProductList",
  "VersionTag",
  "BackToTop"
];

export const routeInfo = {
  id: 'seller-profile',
  name: 'seller-profile',
  pathPattern: '/lojista/:sellerId',
  pathAliases: {
  "path1": "sellerId"
},
  parser: {
    query: {
      "seller_id": unique(),
    },
    cookie: {},
  },
  renderMethod: 'SSR',
  forwardCookies: '',
  forwardHeaders: 'user-agent,referer,theme,x-forwarded-for'
};

export const manifest = {
  "useTypescript": true,
  "deepLinkHost": "https://m.magazineluiza.com.br",
  "isMiniApp": true
};

export const getGlobalClassName = props => ([
    `bg-surface-container-low`,
  ]).join(' ').trim();

export const getPageVariables = props => ({
    sellerPage_sellerPageId: props?.route?.query?.sellerId,
    search_filters: [
      {
        type: `seller`,
        value: props?.route?.query?.sellerId,
      },
    ],
    search_pagination: {
      size: 10,
      page: 1,
    },
    search_showUnavailable: false,
  });

export const middlewaresArgs = ({ 
      "getAppTheme": (props) => ({
  }),
      "getUserInfo": (props) => ({
  }),
      "getVersions": (props) => ({
  }),
      "writePromoterIdCookie": (props) => ({
  }),
 });

export const config = {
  assetPrefix: '',
};
